import {React} from '@api'
import {useVipLocalStore} from '@modules'
import {usePdfStore} from '@modules/pdf'
import {GroupByPagesProps, GroupByPagesStore} from '@modules/pdf/templates/vlp/GroupByPagesStore'
import {GroupByPdfPage} from './GroupByPdfPage'
import {Text} from '@react-pdf/renderer'

export const GroupByPages: React.FunctionComponent<GroupByPagesProps> = function GroupByPages(props) {
  const {data: {total}, download} = props,
    {renderPage} = usePdfStore()

  if (!total || total.value == 0) {
    return renderPage({children: <Text>No Results</Text>}) as any
  }

  // const pagesOld = convertGroupsToPages(groups as IPdfGroupBySearchResult_Group[])

   const store = useVipLocalStore(ws => new GroupByPagesStore(ws, props)),
     {pages, rowsPerPage} = store

  // console.log({pageNew: pages, pagesOld})
  return pages.map((pageInfo, i) => {
    pageInfo = {...pageInfo, rowsPerPage}
    return <GroupByPdfPage pageInfo={pageInfo} key={i} download={download}/>
  }) as any
}


// WEBPACK FOOTER //
// ./src/modules/pdf/templates/vlp/GroupByPages.tsx